import { PlanPresentation } from './plan-presentation';

export default PlanPresentation;
